export const signInUserData = [
    {
        id: '1',
        avatar: '/img/avatars/thumb-1.jpg',
        userName: 'Super Admin Demo',
        fullname: 'Super Admin Demo',
        email: 'superadmin@askred.demo',
        authority: ['Super Admin'],
        role_name: 'Super Admin',
        password: 'Demo1234',
        accountUserName: 'superadmin',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-1.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
    {
        id: '2',
        avatar: '/img/avatars/thumb-2.jpg',
        userName: 'Sysadmin Demo',
        fullname: 'Sysadmin Demo',
        email: 'sysadmin@askred.demo',
        authority: ['Sysadmin'],
        role_name: 'Sysadmin',
        password: 'Demo1234',
        accountUserName: 'sysadmin',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-2.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
    {
        id: '3',
        avatar: '/img/avatars/thumb-3.jpg',
        userName: 'Insurance Demo',
        fullname: 'Insurance Demo',
        email: 'insurance@askred.demo',
        authority: ['Insurance'],
        role_name: 'Insurance',
        password: 'Demo1234',
        accountUserName: 'insurance',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-3.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
    {
        id: '4',
        avatar: '/img/avatars/thumb-4.jpg',
        userName: 'Bank Pusat Demo',
        fullname: 'Bank Pusat Demo',
        email: 'bankpusat@askred.demo',
        authority: ['Bank Pusat'],
        role_name: 'Bank Pusat',
        password: 'Demo1234',
        accountUserName: 'bankpusat',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-4.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: '4',
        cabang_id: null,
    },
    {
        id: '5',
        avatar: '/img/avatars/thumb-5.jpg',
        userName: 'Bank Cabang Demo',
        fullname: 'Bank Cabang Demo',
        email: 'bankcabang@askred.demo',
        authority: ['Bank Cabang'],
        role_name: 'Bank Cabang',
        password: 'Demo1234',
        accountUserName: 'bankcabang',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-5.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: '4',
        cabang_id: '5',
    },
    {
        id: '6',
        avatar: '/img/avatars/thumb-6.jpg',
        userName: 'Broker Demo',
        fullname: 'Broker Demo',
        email: 'broker@askred.demo',
        authority: ['Broker'],
        role_name: 'Broker',
        password: 'Demo1234',
        accountUserName: 'broker',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-6.jpg',
        user_reinsurance: null,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
    {
        id: '7',
        avatar: '/img/avatars/thumb-7.jpg',
        userName: 'Admin Reasuransi Demo',
        fullname: 'Admin Reasuransi Demo',
        email: 'reasuransi@askred.demo',
        authority: ['Sysadmin Reasuransi'],
        role_name: 'Sysadmin Reasuransi',
        password: 'Demo1234',
        accountUserName: 'reasuransi',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-7.jpg',
        user_reinsurance: true,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
    {
        id: '8',
        avatar: '/img/avatars/thumb-8.jpg',
        userName: 'User Reasuransi Demo',
        fullname: 'User Reasuransi Demo',
        email: 'userreasuransi@askred.demo',
        authority: ['Reasuransi'],
        role_name: 'Reasuransi',
        password: 'Demo1234',
        accountUserName: 'userreasuransi',
        project_id: 1,
        project_uuid: 'proj-001',
        is_complete: 1,
        path_avatar: '/img/avatars/thumb-8.jpg',
        user_reinsurance: true,
        va_number: null,
        pusat_id: null,
        cabang_id: null,
    },
]
